export default {
  All: 'all',
  Issues: 'excludePurchases',
  Orders: 'excludeUsage',
}
